jQuery(document).ready(function($) {

	let searchTerm = '';
	let sortBy = '';
	let currentPage = 1;

	// Function to fetch and display all books
	function displayAllBooks() {

		const url = new URL(window.location.href);
		const splitUrl = url.pathname.split('/page/');
		let paged = splitUrl.length > 1 ? splitUrl[1] : 1;
		currentPage = parseInt(paged, 10); // Parse paged to an integer

		// Make Ajax request to retrieve all books
		$.ajax({
			url: wpData.adminAjax,
			type: 'POST',
			data: {
				action: 'books_directory_ajax_callback',
				search_term: '',
				paged: currentPage,
				current_url: window.location.href
			},
			success: function(response) {
				$('.book_dir_content').html(response);
			}
		});
	}

	// Event listener for pagination links
	$(document).on('click', '.pagination a', function(e) {
		e.preventDefault();

		// Get the page number from the link URL
		const url = new URL($(this).attr('href'));
		const paged = url.pathname.split('/page/')[1] || 1;
		currentPage = paged; // Update currentPage

		const currentUrl = window.location.href.replace(/\/page\/\d+\//g, '/');
		const newUrl = currentUrl + 'page/' + paged + '/';

		// Update the paged parameter in the AJAX request
		$.ajax({
			url: wpData.adminAjax,
			type: 'POST',
			data: {
				action: 'books_directory_ajax_callback',
				search_term: searchTerm,
				sort_by: sortBy,
				paged: paged,
				current_url: newUrl
			},
			success: function(response) {
				$('.book_dir_content').html(response);
			}
		});
	});

	$('.book_dir_content').on('click', '.books-container', function() {
		const additionalInfo = $(this).find('.book-additional-info').html();

		elementorProFrontend.modules.popup.showPopup({ id: 69263 });

		$('.book-healer-content-container').html(additionalInfo);
	});

	$('.dir-add-entry').on('click', function(e) {
		e.preventDefault()

		elementorProFrontend.modules.popup.showPopup({ id: 68956 });
	});

	// Ajax handler for the search form
	$('#book_dir_search').on('submit', function(e) {
		e.preventDefault();
		searchTerm = $('#book_dir_search_term').val();
		submitForm();
	});

	// Ajax handler for the sort form
	$(document).on('change', '#book_dir_sort_by', function() {
		sortBy = $(this).val();
		submitForm();
	});

	function submitForm() {

		const url = new URL(window.location.href);
		const splitUrl = url.pathname.split('/page/');
		let paged = splitUrl.length > 1 ? splitUrl[1] : 1;
		currentPage = parseInt(paged, 10); // Parse paged to an integer

		// Make Ajax request and load the results into the container div
		$.ajax({
			url: wpData.adminAjax,
			type: 'POST',
			data: {
				action: 'books_directory_ajax_callback',
				search_term: searchTerm,
				sort_by: sortBy,
				paged: currentPage,
				current_url: window.location.href
			},
			success: function(response) {
				$('.book_dir_content').html(response);
			}
		});
	}

	// Display all books on page initialization
	if ($('.book_dir_content').length > 0) {
		displayAllBooks();
	}
});
